import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { LayoutWrapper } from 'src/domains/layouts/shared/layout/Layout.style';

export const FraudPageWrapper = styled(LayoutWrapper, { label: 'FraudPageWrapper' })`
    background-color: ${mainColors.default.light};
`;
